import classNames from 'classnames'
import { useMemo, CSSProperties } from 'react'
import { deriveAccessibleColors, LineWeight, Spacing } from '@opallabs/gem'
import * as tokenStyles from '../styles'
import { cssTokenVariables } from '../styles'
import { ColorTokenProps, DEFAULT_COLOR } from '../types'
import * as styles from './styles'

export type ColorLabelTokenProps = ColorTokenProps & { label?: string }

export const ColorLabelToken: React.VFC<ColorLabelTokenProps> = ({
  color = DEFAULT_COLOR,
  label,
  className,
  ...props
}) => {
  const { background, foreground, border, hoverBorder } = useMemo(
    () => deriveAccessibleColors(color),
    [color]
  )

  return (
    <span
      className={classNames(tokenStyles.selectors.labelToken, className)}
      css={styles.labelToken}
      style={
        {
          [cssTokenVariables.colorBackground]: background,
          [cssTokenVariables.colorForeground]: foreground,
          [cssTokenVariables.tokenLabelHeight]: `${Spacing.L}px`,
          [cssTokenVariables.tokenBorder]: `${LineWeight.Small}px solid ${border}`,
          [cssTokenVariables.tokenHoverBorder]: `${LineWeight.Small}px solid ${hoverBorder}`,
        } as CSSProperties
      }
      {...props}
    >
      {label}
    </span>
  )
}
ColorLabelToken.displayName = 'Lapidary: ColorLabelToken'
